import axios from 'axios';
import { Config }   from './configActions';

export const FETCH_POSTS                   = 'FETCH_POSTS';
export const FETCH_QTD_COMENTARIOS         = 'FETCH_QTD_COMENTARIOS';
export const FETCH_LISTAR_COMENTARIOS_POST = 'FETCH_LISTAR_COMENTARIOS_POST';
export const FETCH_TURMA_PROFESSOR         = 'FETCH_TURMA_PROFESSOR';
export const FETCH_RANKING_CURSO          = 'FETCH_RANKING_CURSO';
export const ID_TURMA_PROFESSOR            = 'ID_TURMA_PROFESSOR';
export const ADD_COMENTARIO                = 'ADD_COMENTARIO';
export const REMOVER_COMENTARIO            = 'REMOVER_COMENTARIO';
export const ADD_POST                      = 'ADD_POST';
export const ADD_LIKE                      = 'ADD_LIKE';
export const REMOVER_POST                  = 'REMOVER_POST';

var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
Config();
// Turma

export function GetRegistroPostTurma(use_id,que_id) {
 
    const request = axios.get(`/api/turmas/post/listar/${use_id}/${que_id}`,Authorization);

    return{
        type    : FETCH_POSTS,
        payload : request

    };	

}

export function GetQtdCommentPostTurma(pos_id) {

    const request = axios.get(`/api/turmas/comentario/qtd/${pos_id}`,Authorization)

    return{
                type    : FETCH_QTD_COMENTARIOS,
                payload :request

            };
}

export function GetComentariosPostTurma(equ_id_post) {
		

    const request = axios.get(`/api/turmas/comentario/listar/${equ_id_post}`,Authorization);

    return{
        type    : FETCH_LISTAR_COMENTARIOS_POST,
        payload : request

    };
    
}

export function GetRemoverComentarioEquipe(use_id,elem) {
	
     const request = axios.get(`/api/turmas/comentario/apagar/${elem.tur_com_pos_id}/${use_id}`,Authorization);
     const retorno = axios.all([elem,request]);
    
     return{
        type    : REMOVER_COMENTARIO,
        payload : retorno
    };

}

export function GetTurmasProfessor(use_id) {
	
    const request = axios.get(`/api/turmas/listar/professor/${use_id}`,Authorization);
    return{
        type    : FETCH_TURMA_PROFESSOR,
        payload : request

    };    
}

export function GetRankingCurso(use_id) {
    const request = axios.get(`/api/professor/lista/cursos/${use_id}`,Authorization);
    return{
        type    : FETCH_RANKING_CURSO,
        payload : request
    };	
}

export function IdTurmaProfessor(tur_id) {

    return{
        type         : ID_TURMA_PROFESSOR,
        fetch_tur_id : tur_id

    };
 
}

export function SetComentarioPost(dados,comentario){

        //cadastrar um comentario do post
        const requestComentario =  axios.post('/api/turmas/post/comentario/cadastrar',{

            tur_com_pos_cod_turma_post : dados.tur_pos_id,
            tur_com_pos_cod_usuario    : dados.use_id,
            tur_com_pos_comentario     : comentario,

        },Authorization);

       //Buscar a quantidade de comentario do post 
       const requestQtdComentario = axios.get(`/api/turmas/comentario/qtd/${dados.tur_pos_id}`,Authorization);
       const retorno              = axios.all([requestComentario,requestQtdComentario]);
       
        return{
                 type    : ADD_COMENTARIO,
                 payload : retorno 

              }; 
}

export function SendPublic(dados,file){
    

    if (file !==null) {

                const formData = new FormData();
                formData.append('tur_pos_midia', file[0]);
                formData.append('tur_pos_cod_turma', dados.tur_pos_cod_turma);
                formData.append('tur_pos_cod_usuario', dados.tur_pos_cod_usuario);
                formData.append('tur_pos_tipo', dados.tur_pos_tipo);
                formData.append('tur_pos_post', dados.tur_pos_post);
                const request =  axios.post('/api/turmas/post/cadastrar', formData,Authorization);

                return{
                    type    : ADD_POST,
                    payload : request
                };
        
    } else {
               const request = axios.post("/api/turmas/post/cadastrar", {
                                    tur_pos_cod_turma   : dados.tur_pos_cod_turma,
                                    tur_pos_cod_usuario : dados.tur_pos_cod_usuario,
                                    tur_pos_tipo        : dados.tur_pos_tipo,
                                    tur_pos_midia       : dados.tur_pos_midia,
                                    tur_pos_post        : dados.tur_pos_post
                                },Authorization);
                 return{
                         type    : ADD_POST,
                         payload :  request 
                        }; 
    }
    

}

export function GetRemoverPostTurma(use_id,id_post) {
		
   axios.get(`/api/turmas/post/apagar/${id_post}/${use_id}`,Authorization);
    return{
            type    : REMOVER_POST,
            payload : id_post 

        }; 

}

export function SetLikePostUser(equ_post_id,use_id){
        
	 const request = axios.get(`/api/turmas/like/registrar/${equ_post_id}/${use_id}`,Authorization);
     return {
         type    : ADD_LIKE,
         payload : request
     }
}

// Fim Turma


export function GetGruposAlunos(que_id) {
		
    
	return dispatch => {

         return axios.get(`/api/turmas/listar/alunos/${que_id}`,Authorization);
    }

}

export function RemoverAlunoEquipe(alu_id,equ_id,use_id) {
    
	return dispatch => {
      return axios.get(`/api/turmas/remover/aluno/${alu_id}/${equ_id}/${use_id}`,Authorization);
    }

}

export function SetAdicionarAlunoEquipe(dados) {
    
	return dispatch => {
        return axios.post("/api/turmas/adiconar/alunos", {
                alu_equ_cod_aluno     : dados.alu_equ_cod_aluno,
                alu_equ_cod_equipe    : dados.alu_equ_cod_equipe,
                alu_equ_cod_professor : dados.alu_equ_cod_professor
            },Authorization);
    }

}


export function SetValidUrlYoutube(url){
    
    	return dispatch => {
                const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\/)|(\?v=|\&v=))([^#\&\?]*).*/;
                const match = url.match(regExp);

                if (match && match[8].length===11){
                        return 1;
                }else{
                    return 0;
                }
        }
}

export function ClearUrl(url){

    return dispatch => {
            var re = url.replace('https://www.youtube.com/watch?v=','').replace('https://youtu.be/','');

            var url1 = re.split("?").length;
            var url2 = re.split("&").length;

                
            if(url1>1){
                    
                var re1 = re.split("?");		
                return re1[0];

            }


            if(url2>1){
                    
                var re2 = re.split("&");		
                return re2[0];

            }


            if(url1 === 1 || url2 === 1){
                    
                return re;

            }else{

                return "";
            }	

        }

}
 
export function GetTipoMidiaPost(elem){
   
    return dispatch => {     
                const obj = {}
                switch (parseInt(elem.tur_pos_tipo)) {

                    case 2:
                            obj.retorno = `<p><img class="img-responsive" src=${elem.tur_pos_midia} /></p>`;   
                    break;
                
                    case 3:
                            obj.retorno = `<p>
                                        <div class="embed-responsive embed-responsive-4by3">
                                                <iframe 
                                                        width="854" 
                                                        height="480" 
                                                        class="embed-responsive-item" 
                                                        src="${`https://www.youtube.com/embed/${elem.tur_pos_midia}`}" 
                                                        frameborder="0" 
                                                        allowfullscreen>
                                                </iframe>
                                        </div>
                                    </p>`;   
                    break;            
                   

                    default:
                        obj.retorno = null;
                     break;
                }
                return obj.retorno;
         }
   
      }



// WEBPACK FOOTER //
// ./src/actions/turmaAction.js